export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_CHECK = 'USER_CHECK'
export const RESET_USER_STATE = 'RESET_USER_STATE'
